import PathConstants from '@/main/routes/paths'
import { matchPath } from 'react-router-dom'

export function useIsDependent(): boolean {
  return !!matchPath(PathConstants.Routes.DEPENDENT_REQUEST_CONTENT.value, window.location.pathname)
}

export const isDependent = useIsDependent
